export const checkForInternetExplorer11 = () => {
	const tridentVersion = window.navigator.userAgent
		.split(";")
		.find(s => /Trident/.test(s));

	if (tridentVersion) {
		return { ie11: tridentVersion.split("/")[1] };
	}

	return null;
};
